import { addPaymentSource } from './addPaymentSource';
import { cancelPaymentIntentForGiftCards } from './cancelPaymentIntentForGiftCards';
import { chargeUser } from './chargeUser';
import { checkPaymentSource } from './checkPaymentSource';
import { createPaymentTier } from './createPaymentTier';
import { deleteExpiringCredit } from './deleteExpiringCredit';
import { deletePaymentSource } from './deletePaymentSource';
import { fetchCreditUsage } from './fetchCreditUsage';
import { fetchExpiringCredits } from './fetchExpiringCredits';
import { fetchPaymentSources } from './fetchPaymentSources';
import { fetchPaymentTiers } from './fetchPaymentTiers';
import { fetchStripeCharge } from './fetchStripeCharge';
import { fetchLastCallerSubscription } from './fetchLastCallerSubscription';
import { fetchSupervisorRetentionMembershipPrice } from './fetchSupervisorRetentionMembershipPrice';
import { fetchSupervisorRetentionOfferHistory } from './fetchSupervisorRetentionOfferHistory';
import { findOtherUsersWithSameCreditCards } from './findOtherUsersWithSameCreditCards';
import { getCustomChargeRecord } from './getCustomChargeRecord';
import { grantSupervisorRetentionOffer } from './grantSupervisorRetentionOffer';
import { handlePartnerSetupIntentError } from './handlePartnerSetupIntentError';
import { handlePaymentIntentErrorForGiftCards } from './handlePaymentIntentErrorForGiftCards';
import { handleSetupIntentError } from './handleSetupIntentError';
import { makeDefaultCard } from './makeDefaultCard';
import { mapPaymentTiersToOptions } from './mapPaymentTiersToOptions';
import { removeRideCredits } from './removeRideCredits';
import { transferRideCredits } from './transferRideCredits';
import { updatePaymentSource } from './updatePaymentSource';

export const paymentService = {
  addPaymentSource,
  createPaymentTier,
  cancelPaymentIntentForGiftCards,
  chargeUser,
  checkPaymentSource,
  deleteExpiringCredit,
  deletePaymentSource,
  fetchCreditUsage,
  fetchExpiringCredits,
  fetchLastCallerSubscription,
  fetchPaymentSources,
  fetchPaymentTiers,
  fetchStripeCharge,
  fetchSupervisorRetentionMembershipPrice,
  fetchSupervisorRetentionOfferHistory,
  findOtherUsersWithSameCreditCards,
  getCustomChargeRecord,
  grantSupervisorRetentionOffer,
  handlePartnerSetupIntentError,
  handlePaymentIntentErrorForGiftCards,
  handleSetupIntentError,
  makeDefaultCard,
  mapPaymentTiersToOptions,
  removeRideCredits,
  transferRideCredits,
  updatePaymentSource,
};
